import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import memoize from 'lodash/memoize';
import { Store } from 'libx';
import { observable, action } from 'mobx';
import { localStorage as storage } from '../misc/storage';
import { isMobile } from 'utils/mobileDetect';
var sounds = {
  gotMessage: {
    mp3: require('./sounds/got-message.mp3'),
    ogg: require('./sounds/got-message.ogg')
  },
  sendMessage: {
    mp3: require('./sounds/send-message.mp3'),
    ogg: require('./sounds/send-message.ogg')
  }
};
var SoundStore = (_class = /*#__PURE__*/function (_Store) {
  function SoundStore() {
    var _this;
    _classCallCheck(this, SoundStore);
    _this = _callSuper(this, SoundStore, arguments);
    _initializerDefineProperty(_this, "isEnabled", _descriptor, _this);
    _this._getAudio = memoize(_this._getAudio);
    _this.setEnabled(storage.getItem('soundEnabled') !== 'disabled');
    // Initialize all audio objects
    Object.keys(sounds).forEach(function (key) {
      return _this._getAudio(key);
    });
    return _this;
  }
  _inherits(SoundStore, _Store);
  return _createClass(SoundStore, [{
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.isEnabled = enabled;
      storage.setItem('soundEnabled', enabled ? 'enabled' : 'disabled');
    }
  }, {
    key: "playSendMessage",
    value: function playSendMessage() {
      return this._play('sendMessage');
    }
  }, {
    key: "playGotMessage",
    value: function playGotMessage() {
      return this._play('gotMessage');
    }
  }, {
    key: "_play",
    value: function _play(id) {
      if (!this.isEnabled || isMobile()) {
        return;
      }
      var audio = this._getAudio(id);
      audio.pause();
      // Prevents some stupid DOMException, only way to do it.
      // When in doubt, setTimeout
      setTimeout(function () {
        audio.currentTime = 0;
        audio.play();
      }, 10);
    }
  }, {
    key: "_getAudio",
    value: function _getAudio(id) {
      var audio = new window.Audio();
      var type = audio.canPlayType('audio/mpeg') ? 'mp3' : 'ogg';
      audio.volume = 0.6;
      audio.type = type === 'mp3' ? 'audio/mpeg' : 'audio/ogg';
      audio.src = sounds[id][type];
      return audio;
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setEnabled", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setEnabled"), _class.prototype), _class);
export { SoundStore as default };
//# sourceMappingURL=SoundStore.js.map
